import { mountSiteMenu } from 'mk2/apps/blogs/miniapps';

export function initStatic(conf, hydrate = true) {
    const placeholder = conf.node;
    const key = "0";
    const menuSelection = conf.menuSelection;
    const currentUrl = conf.currentUrl;
    mountSiteMenu(placeholder, key, currentUrl, menuSelection, hydrate);
}
